import PaginationComponent from '@/components/common/PaginationComponent';
import QuestionsSkeleton from '@/components/molecules/question-list/QuestionsSkeleton';
import QuestionItem from '@/components/molecules/question-list/question-item';
import useRealtimeWebQnaViewModel from '@/features/qna/realtime-web/view-models/useRealtimeWebQnaViewModel';
import { AdPageType } from '@/models/ad/list';
import { UnifiedAdQnaNative } from '@/shared/ui';
import QnaNativeDefault from '@/shared/ui/QnaNativeDefault';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import Link from 'next/link';
import { Fragment } from 'react';

const RealtimeWebQna = ({ client }: CustomPageProps) => {
  const viewModel = useRealtimeWebQnaViewModel();
  return (
    <>
      {viewModel.isQnaListLoading ? (
        <QuestionsSkeleton />
      ) : (
        <ul>
          {viewModel.questions.map((qna, index) => (
            <Fragment key={`qna-${qna.question.questionPid}`}>
              <li>
                {index === 0 && (
                  <UnifiedAdQnaNative
                    adPageType={AdPageType.QnaListNative}
                    client={client}
                    fallbackContent={
                      <QnaNativeDefault
                        title={'몸살감기 집에서 비대면 진료 가능할까요?'}
                        content={'기침이 심하고 열도 나서 외출이 어려운데, 비대면 진료로 약을 처방 받을 수 있을까요?'}
                        tagList={[{ name: '감기' }, { name: '코로나' }]}
                      />
                    }
                  />
                )}
                <Link href={`${ROUTES.QNA.DETAIL.path}/${qna.question.questionPid}`}>
                  <a>
                    <QuestionItem questionCard={qna} onClickQuestion={() => {}} />
                  </a>
                </Link>
              </li>
            </Fragment>
          ))}
        </ul>
      )}
      <PaginationComponent
        totalPage={viewModel.totalPage}
        queries={viewModel.queries}
        baseUrl={ROUTES.QNA.REALTIME.path}
        currentPage={Number(viewModel.queries.page)}
        scroll={false}
        scrollRestoration={true}
      />
    </>
  );
};

export default RealtimeWebQna;
